import globalConfig from "@/globalConfig.js";
import utils from "@/globalUtil.js";
import { ref, getCurrentInstance } from "vue";

const GlobalController = {
    isLoaded: false,
    isLoading: false,
    get_headers(method = 'get', data = null) {
        let ret = {
            method: method,
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }

        if (method == 'post' && data) {
            ret.body = JSON.stringify(data)
        }

        return ret
    },
    api_call(api_url, result, reject) {
        // Our simplified Backend data call, result or reject.
        // We might reject due an error on an internal error
        fetch(globalConfig.getApiPath(api_url), this.get_headers())
            .then((response) => {
                if (response.status != 200)
                    console.log(" STATUS ACCESSING API " + response.status);

                if (response.status == 503)
                    throw "Unable to connect to the server."

                return response.json();
            })
            .then((data) => {
                if (data.error == 401) {
                    // Token expired or is invalid
                    let token = localStorage.getItem("userToken");
                    if (token) {
                        ["userName", "userToken", "userData"].forEach(item => localStorage.removeItem(item));
                        window.location.reload();
                    }
                    if (reject) return reject(data.error_msg)
                }

                if (data.status != 'success' && data.status != 'deleted') {
                    if (reject) return reject(data.error_msg)
                    //toast.error(data.error_msg)
                    return
                }

                return result(data)
            })
            .catch((error) => {
                if (reject) return reject(error)
                //this.get('alert').setDanger('Error', 'There was a problem accessing this server ' + error)
            })
    },
    get_currentuser(user_callback, error_callback, invalidate = false) {
        // Loads the user from the backend and stores it in localStorage
        // We provide a helper to invalidate the user in case we really want to reload it
        // First time you login it will call the backend.

        if (!invalidate) {
            const userData = utils.getLocalStorageUser();
            if (userData != null) {
                user_callback(userData);
                return;
            }
        }

        this.api_call(
            '/user/get/me',
            (data) => {
                console.log("CONTROLLER: Loaded user " + data.user);
                localStorage.setItem("userData", JSON.stringify(data.user));
                user_callback(data.user);
            },
            (error) => {
                if (!window.location.pathname.includes('/error')) {
                    if (error == "Unable to connect to the server.") {
                        window.location.href = '/error?msg=Unable to connect to the server. Please try again later.';
                        return;
                    };

                    console.log("CONTROLLER: Error loading user " + error);
                    let errormsg = 'Unable to connect to the server. Please try again later.';
                    utils.runToast(` ${errormsg} `, "now-ui-icons ui-1_bell-53", 'bottom-right', 'danger');
                }
                error_callback(error);
            }
        )
    },
    api_set_property(api_entry, entry_id, key, value, result, reject) {
        let api_call = api_entry + "/set/" + entry_id + "/" + key;
        return this.save_json_update(api_call, {
            'value': value
        }, result, reject);
    },
    save_json_update(api_entry, data, result, reject) {
        let api_url = globalConfig.getApiPath(api_entry);
        let headers = this.get_headers('post', data);
        fetch(api_url, headers)
            .then((response) => response.json())
            .then((data) => {
                if (data.status != 'success') {
                    if (reject) return reject(data.error_msg)
                }

                if (result) return result(data)
            })
            .catch((error) => {
                if (reject) return reject(error)

                let errormsg = 'Unable to connect to the server. Please try again later.';
                utils.runToast(` ${errormsg} `, "now-ui-icons ui-1_bell-53", 'bottom-right', 'danger');
            })
    },
    update_currentuser_key(key, value, user_callback, error_callback) {
        this.save_json_update(
            '/user/set/' + key,
            { value: value },
            (data) => {
                console.log("CONTROLLER: Loaded user " + data.user);
                localStorage.setItem("userData", JSON.stringify(data.user));
                user_callback(data.user);
            },
            (error) => {
                console.log("CONTROLLER: Error loading user " + error);
                error_callback(error);
            }
        )
    },
    subscribe_email(email, success_callback, error_callback) {
        this.save_json_update(
            '/subscription/subscribe/email',
            { email: email },
            (data) => {
                console.log("CONTROLLER: Subscribed email " + email);
                success_callback(data);
            },
            (error) => {
                console.log("CONTROLLER: Error subscribing email " + error);
                error_callback(error);
            }
        )
    },
    get_news_link(article) {
        let l = "/n/" + article.id;
        try {
            return l + "#" + utils.cleanTitleForLink(article.title).toUpperCase();
        } catch {
        }
        return l
    },
    get_route_ticker(ticker) {
        return "/ticker/" + ticker;
    },
}

export default GlobalController;